import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {addBaseQueryParams, addURI, transformResponse} from "@commons/utils/APIParams";
import {ElementoRMLSelezionabileRecord} from "@commons/mapping/ElementoRMLSelezionabileRecord";
import {LavoratoreFilterSelection} from "./RMLLavoratore.api";
import {config} from "@commons/config.instance";

export const elementiRMLSelezionatiApi = createApi({
    reducerPath: 'ElementiRMLSelezionatiApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('HR')}),
    endpoints: (builder) => ({

        getElementiXSelezione: builder.query<ElementoRMLSelezionabileRecord[], Partial<LavoratoreFilterSelection>>({
            query: (filter) => {
                let params: string[] = [];
                addBaseQueryParams(filter, params);

                return `/PVA/setup-elementi-RML/lavoratore/${filter.idDip}?${params.length > 0 ? '&' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse: addURI
        }),
        update: builder.mutation<Partial<ElementoRMLSelezionabileRecord>, Partial<ElementoRMLSelezionabileRecord> & Pick<ElementoRMLSelezionabileRecord, 'URI'>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: ({URI, ...patch}) => ({
                url: URI ? URI : '',
                method: 'PATCH',
                body: patch,
            }),
            transformResponse,
            //invalidatesTags: (result, error, {URI}) => [{type: 'Lavoratori', URI}],
        }),
    }),
})
export const {
    useGetElementiXSelezioneQuery,
    useLazyGetElementiXSelezioneQuery,
    useUpdateMutation,
} = elementiRMLSelezionatiApi;